import React, { useState } from "react"
import styles from "./returnSummary.module.scss"
import { getTranslations } from "@/components/Returns/v1/localization"
import { useTranslation } from "next-i18next"
import { NumericFormat } from "react-number-format"
import ToolTip from "@/components/core/ToolTip/ToolTip"
import TooltipIcon from "@/public/icons/tooltip-questionmark.svg"

const ReturnSummary = ({
  data = {},
  currencySign = "",
  returnedItems = {},
  quantityVal = "",
}) => {
  const [tooltipFlag, setTooltipFlag] = useState(false)
  const { t } = useTranslation("common")
  const staticText = getTranslations(t)
  const { price = "", discAmount = "", taxPercentage = "" } = data

  const handleDiscount = (discount, quantityVal, selectedQuantity) => {
    const getDiscount = (discount / quantityVal) * selectedQuantity
    return getDiscount
  }

  const handleTax = (tax, priceVal) => {
    const getTaxPercentage = parseFloat(tax) + 100
    const getTax = Number((tax / getTaxPercentage) * priceVal)?.toFixed(2)
    return getTax ?? 0
  }

  const handleMRP = (price, quantity) => {
    const getMRP = price * quantity
    return getMRP
  }

  const handleTooltip = () => {
    setTooltipFlag(!tooltipFlag)
  }

  return (
    <div className={styles.returnSummary}>
      <h1>{staticText.summaryTitle}</h1>
      <div className="summary-detail summary-detail-total">
        <p> {staticText.summarySubTotal}</p>
        <p>
          <NumericFormat
            value={handleMRP(price, returnedItems?.quantity) ?? 0}
            displayType={"text"}
            thousandSeparator={true}
            prefix={currencySign}
            decimalScale={2}
            fixedDecimalScale={true}
            thousandsGroupStyle={"lakh"}
          />
        </p>
      </div>
      <div className="summary-detail summary-detail-total-discount">
        <p>{staticText.totalDiscount}</p>
        <p>
          <NumericFormat
            value={handleDiscount(
              discAmount,
              quantityVal,
              returnedItems?.quantity
            )}
            displayType={"text"}
            thousandSeparator={true}
            prefix={currencySign}
            decimalScale={2}
            fixedDecimalScale={true}
            thousandsGroupStyle={"lakh"}
            allowNegative={false}
          />
        </p>
      </div>
      <div className="summary-detail summary-detail-shipping">
        <p>
          {staticText.summaryShipping}{" "}
          <img
            src={TooltipIcon.src}
            margin="unset"
            alt={"tooltip"}
            className={"order-summary__tooltip-icon"}
            onMouseOver={() => {
              setTooltipFlag(true)
            }}
            onMouseOut={() => setTooltipFlag(false)}
            onClick={handleTooltip}
          />
        </p>
        {staticText.shippingTooltip && (
          <div
            className={`order-summary__tooltip--${
              tooltipFlag ? "show" : "hide"
            }`}
          >
            <div className="order-summary__tooltip-wrapper">
              <ToolTip message={staticText.shippingTooltip} />
            </div>
          </div>
        )}
        <p>{staticText.summaryFree}</p>
      </div>
      <div className="summary-detail summary-detail-refund">
        <p>{staticText.refundTotal}</p>
        <p>
          <NumericFormat
            value={
              handleMRP(price, returnedItems?.quantity) -
              handleDiscount(discAmount, quantityVal, returnedItems?.quantity)
            }
            displayType={"text"}
            thousandSeparator={true}
            prefix={currencySign}
            decimalScale={2}
            fixedDecimalScale={true}
            thousandsGroupStyle={"lakh"}
          />
        </p>
      </div>
      <div className="summary-detail summary-detail-tax">
        <p> {staticText.summaryTax}</p>
        <div className="summary-tax-section">
          <p>{staticText.including}</p>
          <p>
            <NumericFormat
              value={handleTax(
                taxPercentage,
                handleMRP(price, returnedItems?.quantity) -
                  handleDiscount(
                    discAmount,
                    quantityVal,
                    returnedItems?.quantity
                  )
              )}
              displayType={"text"}
              thousandSeparator={true}
              prefix={currencySign}
              decimalScale={2}
              fixedDecimalScale={true}
              thousandsGroupStyle={"lakh"}
            />
          </p>
          <p>{staticText.taxes}</p>
        </div>
      </div>
      <div className="call-support">
        <p className="call-support-call">{staticText.summaryCall}</p>
        <a href="tel:1-800-103-2244">{staticText.summaryTel}</a>
      </div>
    </div>
  )
}

export default ReturnSummary
